import { css } from '@emotion/core'

export default ({ theme: { colors, typography }, isDiscounted }) => css`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  span {
    display: inline-flex;
    align-self: baseline;
  }

  .price {
    color: ${isDiscounted ? colors.discount : colors.body};
  }

  .original-price {
    margin-left: 1rem;
    color: ${colors.text2};
    position: relative;
    text-decoration: line-through;
  }
`
